import React, { useContext, useEffect, useState } from "react";
import { Card, Button, Tag, message, Popover } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import CarrierAi from "../../../assets/welcome/carrierai.png";
import LinkedIn from "../../../assets/welcome/LinkedIn.png";
import Jobswipe from "../../../assets/welcome/jobswipe.png";
import { ReactComponent as Occupation } from "../../../assets/chart-icon.svg";
import constants from "../../../constants/constants";
import WebLinks from "../../../api/WebLinks";
import Cookies from 'js-cookie';
import APIUtils from "../../../api/APIUtils";
import { CommonContext, CurrencyContext } from "../../../Context";

const dashboardCards = [
  {
    id: 1,
    title: "AI-powered candidate discovery",
    description: [
      "Put your jobs in front of candidates using Cassie.AI, an intelligent careers assistant designed to help jobseekers find better-matched opportunities.",
    ],
    logo: CarrierAi,
    badge: "SPECIAL OFFER",
    badgeColor: "#ff7a45",
    buttonText: "Find Out More",
    mainTitle:".Cassie",
  },
  {
    id: 2,
    title: "50% off - Always-on mobile candidate reach",
    description: [
      "Keep your roles visible to mobile-first candidates through JobSwipe's swipe-based job discovery experience.",
      "One simple Annual Fee will post all your roles to JobSwipe.",
    ],
    logo: Jobswipe,
    badge: "SPECIAL OFFER",
    badgeColor: "#ff7a45",
    buttonText: "Find Out More",
    mainTitle:"JobSwipe",
  },
  {
    id: 3,
    title: "Easily Boost Your Jobs to Linkedin",
    description: [
      "Hire Intelligence offers the only LinkedIn integration in the UK. Allowing you to boost your jobs directly on LinkedIn and return candidates to your ATS.",
    ],
    logo: LinkedIn,
    badge: "NEW FEATURE",
    badgeColor: "#ef3f9b",
    buttonText: "Find Out More",
    mainTitle:"LinkedIn",
  },
  {
    id: 4,
    title: "Occupation or Location Landing Pages",
    description: [
      "Create occupation or location specific landing pages that combine role information, employer content and live vacancies in one place. Use these for Social Media and Google Ads campaigns and increase conversion rates by over 100% and attract high quality passive candidates.",
    ],
    icon: <Occupation className="w-12 h-12" />,
    badge: "NEW FEATURE",
    badgeColor: "#ef3f9b",
    buttonText: "Find Out More",
    mainTitle:"Landing Pages",
  },
];
const shuffleArray = (array) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
  }
  return arr;
};

const Welcome = (props) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(null);
  const [linkedinPopoverVisible, setLinkedinPopoverVisible] = useState(false);
  const history = useHistory();
  const currencyContext=useContext(CurrencyContext);
  const commonContext=useContext(CommonContext);

  const goToBoostTab = (card) => {
    setLinkedinPopoverVisible(false);
    history.push("/your-jobs", { activeTab: "3" });
  };

  const linkedinBoostContent = (
    <div className="text-sm text-gray-700 max-w-xs">
      <p className="font-semibold text-black mb-2">It is so easy to boost your jobs onto Linkedin</p>
      <ol className="list-decimal pl-5 space-y-1">
        <li>
          <button
            type="button"
            className="font-medium text-blue-600 underline underline-offset-2"
            onClick={() => goToBoostTab({ id: 3, mainTitle: "LinkedIn", title: "Easily Boost Your Jobs to Linkedin" })}
          >
           Click Here
          </button>{' '}
          to go to the 'Buy Job Board Boosts' Tab
        </li>
        <li>Add your jobs to the shopping basket</li>
        <li>Select the Linkedin Boost and confirm!</li>
      </ol>
    </div>
  );

  useEffect(() => {
    if(props?.location?.state?.verificationStatus==="t"){
      getBuyerDetails(Cookies.get(constants.COOKIE_LOGGED_BUYER_ID))
    }
    setCards(shuffleArray(dashboardCards));
    setLoading(false);
  }, []);

  const sendEmail = async (card) => {
    setLoadingButton(card.id);
    const payload = {
      buyerId: Number(Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)),
      productName: `${card.mainTitle} - ${card.title}`,
    };
    try {
      const response = await fetch(WebLinks.GetMoreInfo, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get(constants.COOKIE_TOKEN)}`,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.statusCode === "2000") {
        message.success(constants.WelcomeSuccessText);
      } else {
        message.error(result.message || "Something went wrong");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Failed to send request");
    } finally {
      setLoadingButton(null);
    }
  };

  const getBuyerDetails = async (buyerId) => {
    setLoading(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetBuyerDetails + buyerId);
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      currencyContext.changeCurrencyValue(constants.CurrencyConstants[response.resultObj?.data?.cpaCurrency||"GBP"])
      await commonContext.changeCommonValues({'boostCredits':response.resultObj?.data?.boostCredits||0});
      await sessionStorage.setItem('isSelfService', response.resultObj?.data?.selfService);
      await sessionStorage.setItem('isBoost', response.resultObj?.data?.showBoost);
      await sessionStorage.setItem('clickPost', response.resultObj?.data?.clickPost);
      await sessionStorage.setItem('allowCreditInvoicing', response.resultObj?.data?.allowCreditInvoicing);
      await sessionStorage.setItem('selectedissubbuyeradmin', response.resultObj?.data?.subBuyerAdmin);
      await sessionStorage.setItem('selectedbuyerselfpost', response.resultObj?.data?.selfPost);
      await sessionStorage.setItem('selectedbuyername', response.resultObj?.data?.label);
      await sessionStorage.setItem('emailpost', response.resultObj?.data?.emailPost);
      message.info("Please select a buyer before proceeding...")
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-xl font-bold text-black mb-8">
          Current special offers and new features
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((card) => (
            <Card
              key={card.id}
              loading={loading}
              bordered={false}
              className="
                rounded-xl
                shadow-sm
                hover:shadow-xl
                transition-all
                duration-300
                border
                border-gray-200
                h-full
              "
              bodyStyle={{
                padding: 30,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <div className="flex items-start justify-between gap-3 mb-8">
                <div className="w-36 h-12 flex items-center justify-start flex-shrink-0">
                  {card.logo ? (
                    <img
                      src={card.logo}
                      alt={card.title}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center">
                      {card.icon}
                    </div>
                  )}
                </div>

                <Tag
                  bordered={false}
                  className="!m-0 flex-shrink-0"
                  style={{
                    backgroundColor: card.badgeColor,
                    color: "#fff",
                    fontWeight: 600,
                    borderRadius: 5,
                    padding: "4px 12px",
                    fontSize: 12,
                    whiteSpace: "nowrap",
                  }}
                >
                  {card.badge}
                </Tag>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold leading-tight mb-5">
                {card.title}
              </h3>
              {/* Description */}
              <div className="leading-5 flex-grow">
                {Array.isArray(card.description) ? (
                  card.description.map((line, index) => (
                    <p key={`${card.id}-${index}`} className="mb-2 last:mb-0">
                      {line}
                    </p>
                  ))
                ) : (
                  <p>{card.description}</p>
                )}
              </div>
              {/* Button */}
              {card.mainTitle === "LinkedIn" ? (
                <Popover
                  content={linkedinBoostContent}
                  trigger="click"
                  placement="right"
                  open={linkedinPopoverVisible}
                  onOpenChange={(visible) => setLinkedinPopoverVisible(visible)}
                >
                  <Button
                    type="primary"
                    icon={<ArrowRightOutlined />}
                    iconPosition="end"
                    style={{
                      background: card.buttonColor,
                      borderColor: card.buttonColor,
                    }}
                    loading={loadingButton === card.id}
                    className="mt-8 w-fit px-4 uppercase"
                    onClick={() => {
                      sendEmail(card);
                    }}
                  >
                    {card.buttonText}
                  </Button>
                </Popover>
              ) : (
                <Button
                  type="primary"
                  icon={<ArrowRightOutlined />}
                  iconPosition="end"
                  style={{
                    background: card.buttonColor,
                    borderColor: card.buttonColor,
                  }}
                  loading={loadingButton === card.id}
                  className="mt-8 w-fit px-4 uppercase"
                  onClick={() => {
                    sendEmail(card);
                  }}
                >
                  {card.buttonText}
                </Button>
              )}
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Welcome;
